import { create } from 'zustand';

type AuthRole = 'admin' | 'organizer';

interface AuthState {
  isAuthenticated: boolean;
  username: string | null;
  role: AuthRole | null;
  setAuthenticated: (username: string, role: AuthRole) => void;
  clearAuthenticated: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  username: null,
  role: null,
  setAuthenticated: (username, role) => set({ isAuthenticated: true, username, role }),
  clearAuthenticated: () => set({ isAuthenticated: false, username: null, role: null }),
}));
